import { Component, createRef } from "react"

/* Components */
import { Avatar, DataLayout, Icon } from "../../components"

/* Widgets */
import { CreateModal, DetailsModal, FilterModal, SendModal, INITIAL_FILTER, filterCount } from "../../widgets/notification"

/* Shared */
import { notificationIcon, stateOf, typeOf } from "../../widgets/notification/shared"

/* REST API */
import { templates } from "../../api/Notification"

/* Constants */
import { env } from "../../constants"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

moment.locale("ru")


/* Page Notifications — the templates of the panel. The page repeats the look of the records:
   the same line of tools, the same rows and the same panel from the right */
class Notifications extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            list: [],
            search: "",
            filter: { ...INITIAL_FILTER },

            /* The form of the template keeps its own window — it is drawn by the state,
               the rest of the windows open by the reference */
            createModal: false,
            copyData: null,
            sendModal: false,
            active: null
        }

        this._details = createRef()
        this._filter = createRef()
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
        this.load()
    }

    /* Load action */
    load = () => {

        this.setState({ status: "loading" })

        templates().then(response => {
            if (response && response.status === 200) {
                this.setState({ list: response.data.list, status: "ok" })
            }
            else {
                this.setState({ status: "error", list: [] })
            }
        }).catch(() => this.setState({ status: "network", list: [] }))
    }

    /* The templates which the search and the filter left on the page */
    found = () => {

        /* Fields */
        const { list, search, filter } = this.state

        const text = search.trim().toLowerCase()

        return list.filter(item => {

            if (`${filter.type}` !== "all" && item.type !== filter.type) {
                return false
            }

            if (`${filter.state}` !== "all" && `${parseInt(item.sent) === 1 ? 1 : 0}` !== `${filter.state}`) {
                return false
            }

            if (text.length === 0) {
                return true
            }

            return `${item.title} ${item.description}`.toLowerCase().indexOf(text) > -1
        })
    }

    /* Copy a template into a new draft */
    copy = item => {
        this.setState({
            createModal: true,
            copyData: {
                type: item.type,
                title: `${item.title}`,
                description: item.description,
                button: utils.check(item.button, ""),
                buttonColor: utils.check(item.buttonColor, "#0279fc"),
                screen: utils.check(item.screen, ""),
                params: utils.check(item.params, ""),
                image: utils.check(item.image, "")
            }
        })
    }

    /* Draw one template of the table */
    _item = (item, index) => {

        const type = typeOf(item.type)
        const state = stateOf(item.sent)
        const image = item.image ? `${env.mediapoint}notifications/${item.image}` : null

        return (
            <div onClick={() => this._details.current.open(item)} className="nt-item" key={`${index}`}>

                <div className="nt-item-cell main">

                    <Avatar className="nt-item-avatar" src={image} alt={item.title}>
                        {notificationIcon()}
                    </Avatar>

                    <div className="nt-item-title">
                        <div className="nt-item-name">
                            {utils.check(item.title, "Без заголовка")}
                            {item.image && <div className="nt-item-badge">фото</div>}
                        </div>
                        <div className="nt-item-text">{utils.check(item.description, "—")}</div>
                    </div>

                </div>

                <div className="nt-item-cell type">
                    <div className="nt-item-value">{type.text}</div>
                    <div className="nt-item-text">получатели</div>
                </div>

                <div className="nt-item-cell action">
                    <div className="nt-item-value">{utils.check(item.button, "Без кнопки")}</div>
                    <div className="nt-item-text">{utils.check(item.screen, "переход не задан")}</div>
                </div>

                <div className="nt-item-cell date">
                    <div className="nt-item-value">{moment(item.createdAt).format("DD.MM.YYYY")}</div>
                    <div className="nt-item-text">{moment(item.createdAt).format("HH:mm")}</div>
                </div>

                <div className="nt-item-cell state">
                    <div className={`nt-item-state ${state.accent}`}>
                        <i />
                        {state.text}
                    </div>
                </div>

                <div className="nt-item-cell arrow">
                    <Icon name="right" size={15} width={2} />
                </div>

            </div>
        )
    }

    /* The numbers of the section — one slim line over the table */
    _summary = () => {

        /* Fields */
        const { list } = this.state

        const sent = list.filter(item => parseInt(item.sent) === 1).length
        const clients = list.filter(item => item.type === "client").length

        return (
            <div className="nt-summary">

                <div className="nt-summary-title">
                    <span>Шаблоны</span>
                    Уведомления приложениям
                </div>

                <div className="nt-summary-values">
                    <div className="nt-summary-value">Всего <b>{list.length}</b></div>
                    <div className="nt-summary-value">Отправлены <b className="blue">{sent}</b></div>
                    <div className="nt-summary-value">Черновики <b className="orange">{list.length - sent}</b></div>
                    <div className="nt-summary-value">Клиентам <b>{clients}</b></div>
                    <div className="nt-summary-value">Мастерам <b>{list.length - clients}</b></div>
                </div>

            </div>
        )
    }

    /* Draw Header */
    _header = () => {

        /* Fields */
        const { search, filter } = this.state

        const active = filterCount(filter)

        return (
            <div className="nt-header">

                <div className="page-header-text">Уведомления</div>

                <div className="nt-header-tools">

                    <form onSubmit={event => event.preventDefault()} className="nt-search">

                        <div className="nt-search-icon">
                            <Icon name="search" size={17} />
                        </div>

                        <input placeholder="Заголовок или текст" value={search} onChange={event => this.setState({ search: event.target.value })} />

                        {search.length > 0 &&
                            <div onClick={() => this.setState({ search: "" })} className="nt-search-clear">
                                <Icon name="close" size={11} width={2.4} />
                            </div>
                        }

                    </form>

                    <div onClick={() => this._filter.current.open(filter)} title="Фильтр" className={`nt-filter-button ${active > 0 ? "active" : ""}`}>
                        <Icon name="filter" size={19} />
                        {active > 0 && <div className="nt-filter-count">{active}</div>}
                    </div>

                    <div onClick={() => this.setState({ createModal: true, copyData: null })} className="nt-create-button">
                        <Icon name="plus" size={16} width={2.4} />
                        <span>Создать</span>
                    </div>

                </div>

            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status } = this.state

        const data = this.found()

        if (status !== "ok" || data.length === 0) {
            return (
                <div className="page-content">
                    {status === "ok" && this._summary()}
                    <DataLayout status={status} reload={this.load} data={data} />
                </div>
            )
        }

        return (
            <div className="page-content">

                {this._summary()}

                <div className="nt-list">

                    <div className="nt-item head">
                        <div className="nt-item-cell main">Уведомление</div>
                        <div className="nt-item-cell type">Кому</div>
                        <div className="nt-item-cell action">Кнопка</div>
                        <div className="nt-item-cell date">Создан</div>
                        <div className="nt-item-cell state">Статус</div>
                        <div className="nt-item-cell arrow" />
                    </div>

                    {data.map((item, index) => this._item(item, index))}

                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { createModal, copyData, sendModal, active } = this.state

        return (
            <div className="page">

                {/* Draw Header */}
                {this._header()}

                {/* Draw Content */}
                {this._content()}

                {/* Draw Details */}
                <DetailsModal
                    ref={this._details}
                    onSend={item => this.setState({ sendModal: true, active: item })}
                    onCopy={this.copy}
                    onRemoved={this.load}
                />

                {/* Draw Filters */}
                <FilterModal ref={this._filter} onApply={filter => this.setState({ filter })} />

                {/* Draw Form */}
                <CreateModal
                    visible={createModal}
                    initial={copyData}
                    onClose={() => this.setState({ createModal: false, copyData: null })}
                    onSaved={this.load}
                />

                {/* Draw Sending */}
                <SendModal
                    visible={sendModal}
                    template={active}
                    onClose={() => this.setState({ sendModal: false, active: null })}
                    onSent={id => this.setState(previous => ({ list: previous.list.map(item => item.id === id ? { ...item, sent: 1 } : item) }))}
                />

            </div>
        )
    }
}

export default withRouter(Notifications)
